import { SharedModule } from 'src/app/shared/shared.module';
import { NgModule } from '@angular/core';
import { AppointmentListSectionComponent } from './appointment-list-section/appointment-list-section.component';
import { CommonModule } from '@angular/common';
import { EventModule } from '../event/event.module';
import { AppointmentConfirmComponent } from './appointment-confirm/appointment-confirm.component';

@NgModule({
    declarations: [
        AppointmentListSectionComponent,
        AppointmentConfirmComponent
    ],
    imports: [
        CommonModule,
        SharedModule,
        EventModule
    ],
    exports: [
        AppointmentListSectionComponent
    ]
})
export class AppointmentModule { }
